import type { TextPropSize, TextPropView } from '@consta/uikit/Text'
import type { AlgorithmParams, HorizonsExtensionParams } from '@core/core/types'
import type { FC } from 'react'

import { Common } from '../Common'

type HorizonExtensionProps = {
  algorithm: AlgorithmParams
  textProps?: { size: TextPropSize; view: TextPropView }
  handleChange: (field: keyof HorizonsExtensionParams, value: string | number | boolean) => void
}

export const HorizonExtension: FC<HorizonExtensionProps> = ({
  algorithm,
  textProps,
  handleChange,
}) => {
  return <Common algorithm={algorithm} handleChange={handleChange} textProps={textProps} />
}
